import { render, staticRenderFns } from "./addImdb.vue?vue&type=template&id=e868c58e"
import script from "./addImdb.vue?vue&type=script&lang=js"
export * from "./addImdb.vue?vue&type=script&lang=js"
import style0 from "./addImdb.vue?vue&type=style&index=0&id=e868c58e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports